import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
class UserForm extends CBcDialogForm {
    constructor(form) {
        super();
        const that = this;
        if (form) {
            Object.keys(form).forEach((k) => {
                that[k] = form[k];
            });
        }
    }
}
let UserProfile = class UserProfile extends Vue {
    constructor() {
        super();
        this.dialog = new CBcDialog(new UserForm());
        this.snackbar = new CBcSnackbar();
        this.profile = { usersInfo: {} };
        this.verityCode = '';
        this.verityCodeTime = 0;
        this.editable = false;
        this.generated = false; // 是否获取了验证码
        this.generating = false; // 是否正在获取验证码
        this.form = {
            valid: false
        };
        const that = this;
    }
    mounted() {
        const that = this;
        that.getProfile();
    }
    get emailState() {
        const that = this;
        if (that.profile) {
            const mails = that.profile.mailInfo;
            const curMail = that.profile.usersInfo && that.profile.usersInfo.email;
            if (mails && mails.length) {
                const it = mails.find((v) => v.email === curMail);
                return it && it.state || '';
            }
            else
                return curMail ? '未验证' : '';
        }
        else
            return '';
    }
    calVerityCodeRetryTime(time) {
        const that = this;
        if (time)
            that.verityCodeTime = time;
        const timer = setInterval(() => {
            if (that.verityCodeTime >= 60) {
                clearInterval(timer);
                that.verityCodeTime = 0;
            }
            else
                that.verityCodeTime += 1;
        }, 1000);
    }
    async getProfile() {
        const that = this;
        try {
            const d = await that.axios.get(`/api/users/${that.userInfo.id}`);
            that.profile = d && d.data && d.data.result;
            that.dialog.form = new UserForm(that.profile);
        }
        catch (e) {
            that.snackbar.error('获取用户信息出错:' + (e && (e.error || e.info || e.result)));
        }
    }
    async save() {
        const that = this;
        try {
            const resUpdate = await that.axios.put(`/api/users/${that.profile.id}`, that.profile.usersInfo);
            // console.log('update user profile:', resUpdate)
            that.snackbar.success('用户信息更新成功');
            that.editable = false;
        }
        catch (e) {
            console.log('error to save user profile:', e);
            that.snackbar.error('用户信息更新失败：' + e && (e.info || e.result || e.errorInfo || e.error || e.toString()));
        }
    }
    openMailVerity() {
        const that = this;
        if (/已验证/i.test(that.emailState))
            return;
        that.dialog.title = '邮箱验证';
        that.dialog.persistent = true;
        that.dialog.autoClose = false;
        that.dialog.form.valid = true;
        that.generated = false;
        that.dialog.visible = true;
    }
    async getEmailVerityCode() {
        const that = this;
        that.generating = true;
        try {
            const r = await that.axios.post('/api/email/user/generate', { userId: that.profile.id, email: that.profile.usersInfo.email });
            that.calVerityCodeRetryTime();
            that.generating = false;
            that.generated = true;
            that.snackbar.success(r && r.data.result);
        }
        catch (e) {
            const errCode = e && e.errorCode;
            const errTime = e && e.time;
            if (Number(errCode) === 1002 && errTime) {
                that.generated = true;
                that.calVerityCodeRetryTime(60 - Number(errTime));
            }
            that.generating = false;
            that.snackbar.error('用户邮箱验证出错: ' + (e && (e.info || e.result || e.error)), 10000);
        }
    }
    async verity() {
        const that = this;
        that.dialog.loading = true;
        try {
            const r = await that.axios.post('/api/email/user/verify', { userId: that.profile.id, code: that.verityCode, email: that.profile.usersInfo.email });
            that.snackbar.success(r.data.result);
            that.dialog.loading = false;
            that.dialog.visible = false;
            that.verityCode = '';
            that.getProfile();
        }
        catch (e) {
            that.dialog.loading = false;
            that.snackbar.error('用户邮箱验证出错: ' + (e && (e.info || e.result || e.error)));
        }
    }
};
__decorate([
    Getter
], UserProfile.prototype, "userInfo", void 0);
UserProfile = __decorate([
    Component({
        name: 'Home',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], UserProfile);
export default UserProfile;
;
